export default {
  namespaced: true,
  state: {
    currency: 'PLN',
    ratio: 1,
  },
  mutations: {
    setCurrency(state, currencyCode) {
      if (currencyCode === 'PLN') {
        state.currency = currencyCode;
        state.ratio = 1;
      } else if (currencyCode === 'EUR') {
        state.currency = 'EUR';
        state.ratio = 4.4;
      }
    }
  }
}
